import React  from 'react';
import './App.css';
import './Source.css';
import SourceLang from './SourceLang.json';

import { useNavigate } from "react-router-dom";

class SourceResult extends React.Component {

	constructor(props) {

		super(props);

		this.state = {
			notebookJsonObj: null,
			sourceArray: null,
			outText: "",
		}
	}

	async componentDidMount() {

		var notebookID = this.props.notebookID;
		var sourceIndex = this.props.sourceIndex;

		var notebookJsonObj = await this.props.serverGetNotebookData(notebookID);
		var sourceArray = await this.props.serverGetSourceList(notebookID);
		this.setState({
			notebookJsonObj: notebookJsonObj,
			sourceArray: sourceArray,
		});

		var notebookStorageID = notebookJsonObj.storageID;		
		var itemObj = sourceArray[sourceIndex];
		var filenameExt = itemObj.filename;
		var filename = filenameExt.substring(0, filenameExt.lastIndexOf('.'));
		var filenameOut = filename + ".out";
		var outText = await this.props.serverStorageProxy(notebookStorageID, filenameOut);
		this.setState({
			outText: outText,
		});
	}
	
	onClickBackToNotebook() {
		var navigate = this.props.navigate;
  		navigate("/notebook");
	}

	render() {

		var notebookJsonObj = this.state.notebookJsonObj;
		if (notebookJsonObj === null) {
			return;
		}

		var sourceArray = this.state.sourceArray;
		if (sourceArray === null) {
			return;
		}

		var notebookID = this.props.notebookID;
		var sourceIndex = this.props.sourceIndex;
		var notebookTitle = notebookJsonObj.title;
		
		var itemObj = sourceArray[sourceIndex];
		var filenameExt = itemObj.filename;
		var filename = filenameExt.substring(0, filenameExt.lastIndexOf('.'));
		
		var outText = this.state.outText;
		var outTextJsx = this.props.convertTextToJsx(outText, "outText", "");

		return (
			<div className="SourceResultTopContainer">
				<div style={{height: "12px"}}></div>
				<div className="SourceResultTitle"><b>{this.props.getLang(SourceLang, "notebook")}</b>: {notebookTitle}</div>
				<div className="SourceResultTitle"><b>{this.props.getLang(SourceLang, "source")}</b>: {filename}</div>
				<hr className="NotebookCustomLine" />
				<div className="SourceResultTitle">{outTextJsx}</div>
				<div style={{height: "20px"}}></div>
				<button className="NotebookGreyButton" onClick={() => this.onClickBackToNotebook()}>{this.props.getLang(SourceLang, "backToNotebook")}</button>
				<div style={{height: "30px"}}></div>
			</div>
		);
	}
}

export default function SourceResultFunction(props) {
	const navigate = useNavigate();
	return <SourceResult {...props} navigate={navigate} />;
}

